module.exports = __webpack_public_path__ + "img/jing1.f5448e70.jpg";